import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Row, Col, Card, Label, Spinner, CardBody } from "reactstrap"
import { URLS } from "../../Url"
import axios from "axios"
import { ToastContainer, toast } from "react-toastify"

const AboutUs = () => {
  const [aboutData, setAboutData] = useState({
    bannerImage: "",
    description: "",
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchAboutData()
  }, [])

  const fetchAboutData = async () => {
    try {
      const authUser = localStorage.getItem("authUser")
      if (!authUser) {
        throw new Error("Authentication required")
      }

      const token = JSON.parse(authUser).token
      const response = await axios.post(
        URLS.GetAbout,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      if (response.data && response.data.aboutus) {
        setAboutData(response.data.aboutus)
      }
    } catch (error) {
      console.error("Error fetching about data:", error)
      setError(error.message || "Failed to load about us data")
      toast.error(error.message || "Failed to load about us data")
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="About Us" />
          <div className="text-center py-5">
            <Spinner color="primary" />
            <p>Loading about us information...</p>
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="About Us" />
          <div className="alert alert-danger">{error}</div>
        </div>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="About Us" />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="text-center mb-2 mt-2">
                    <h3 className="text-primary">About Us</h3>
                  </div>
                  <hr></hr>
                  <Row>
                    <Col md={4} className="mt-3">
                      {aboutData.bannerImage && (
                        <img
                          src={`${URLS.Base}${aboutData.bannerImage}`}
                          alt="About Us Banner"
                          className="img-fluid rounded"
                          style={{
                            maxHeight: "300px",
                            width: "100%",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </Col>
                    <Col md={12} className="mt-3 mb-3">
                      <Label className="h4">About Us</Label>
                      <div
                        className="mt-3"
                        dangerouslySetInnerHTML={{
                          __html: aboutData.description,
                        }}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer position="top-right" autoClose={5000} />
        </div>
      </div>
    </React.Fragment>
  )
}

export default AboutUs
